import PropTypes from 'prop-types';
import { useState } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Popup } from 'semantic-ui-react';
import Button from '@package/components/Button';
import Icon from '@package/components/Icon';
import {
  faFacebook,
  faLinkedin,
  faWhatsapp,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const timeoutLength = 2500;

const messages = defineMessages({
  share_on: {
    id: 'Share on',
    defaultMessage: 'Share on',
  },
  share: {
    id: 'Share',
    defaultMessage: 'Share',
  },
  copy_page_link: {
    id: 'Copy page link',
    defaultMessage: 'Copy page link',
  },
});

export const DEFAULT_SOCIAL = [
  {
    name: 'Whatsapp',
    color: '#00bb2d',
    sharing_url: 'https://api.whatsapp.com/send?text=',
    only_mobile: true,
    faIcon: faWhatsapp,
  },
  {
    name: 'Facebook',
    color: '#3b5998',
    sharing_url: 'http://www.facebook.com/sharer.php?u=',
    faIcon: faFacebook,
  },
  {
    name: 'Twitter',
    color: '#00acee',
    useText: true,
    sharing_url: 'https://twitter.com/share?url=',
    faIcon: faXTwitter,
  },
  {
    name: 'Linkedin',
    color: '#4FA1C6',
    sharing_url: 'https://linkedin.com/shareArticle/?url=',
    only_mobile: true,
    faIcon: faLinkedin,
  },
];

const SocialShareButton = ({ network, url, text, intl }) => {
  const textParam = network.useText && text ? `&text=${text}` : '';

  const shareLink = `${network.sharing_url}${url}${textParam}`;
  const share_on = intl.formatMessage(messages['share_on']);

  return (
    <Button
      link
      circle
      small
      forceExternal
      rel="noopener noreferrer"
      target="_blank"
      title={`${share_on} ${network.name}`}
      href={shareLink}
    >
      <FontAwesomeIcon icon={network.faIcon} />
    </Button>
  );
};

const SocialShare = ({ intl, url, text }) => {
  const [isOpenTooltip, setIsOpenTooltip] = useState(false);

  const handleOpen = () => {
    setIsOpenTooltip(true);

    setTimeout(() => {
      setIsOpenTooltip(false);
    }, timeoutLength);
  };

  const handleClose = () => {
    setIsOpenTooltip(false);
  };

  const copyClipBoard = () => {
    navigator.clipboard.writeText(url);
    handleOpen();
  };

  return (
    <div className="social-share">
      <span className="label">{intl.formatMessage(messages.share)}: </span>

      {DEFAULT_SOCIAL.map((network) => (
        <SocialShareButton
          network={network}
          url={url}
          text={text}
          intl={intl}
          key={network.name}
        />
      ))}

      <Popup
        trigger={
          <Button
            small
            link
            circle
            title={intl.formatMessage(messages['copy_page_link'])}
            onClick={copyClipBoard}
          >
            <Icon name="link" />
          </Button>
        }
        open={isOpenTooltip}
        onClose={handleClose}
      >
        <Popup.Content>Link copiado com sucesso!</Popup.Content>
      </Popup>
    </div>
  );
};

SocialShare.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(SocialShare);
